
const fr_FR = {
  strings: {},
  pluralize(count) {
    if (count === 1) {
      return 0;
    }
    return 1;
  },
};
fr_FR.strings = {
  addBulkFilesFailed: {
    0: 'L’ajout de %{smart_count} fichier a échoué',
    1: 'L’ajout de %{smart_count} fichiers a échoué',
  },
  addedNumFiles: '%{numFiles} fichier(s) ajouté(s)',
  addingMoreFiles: 'Ajout de fichiers',
  additionalRestrictionsFailed: '%{count} restrictions additionnelles n\'ont pas été remplies',
  addMore: 'Ajouter d’autres',
  addMoreFiles: 'Ajouter d’autres fichiers',
  allFilesFromFolderNamed: 'Tous les fichiers du dossier %{name}',
  allowAccessDescription: 'Pour prendre des photos ou enregistrer une vidéo, veuillez autoriser l’accès à votre caméra pour ce site.',
  allowAccessTitle: 'Veuillez autoriser l’accès à votre caméra',
  allowAudioAccessDescription: 'Pour enregistrer de  l\'audio, veuillez autoriser l’accès à votre microphone pour ce site.',
  allowAudioAccessTitle: 'Veuillez autoriser l’accès à votre microphone',
  aspectRatioLandscape: 'Rogner paysage (16:9)',
  aspectRatioPortrait: 'Rogner portrait (9:16)',
  aspectRatioSquare: 'Rogner carré',
  authAborted: 'Authentification interrompue',
  authenticateWith: 'Se connecter à %{pluginName}',
  authenticateWithTitle: 'Veuillez vous authentifier avec %{pluginName} pour sélectionner les fichiers',
  back: 'Retour',
  browse: 'parcourir',
  browseFiles: 'parcourir les fichiers',
  browseFolders: 'parcourir les répertoires',
  cancel: 'Annuler',
  cancelUpload: 'Annuler l’import',
  chooseFiles: 'Choisir des fichiers',
  closeModal: 'Fermer la fenêtre',
  companionError: 'La connexion à Companion a échoué',
  companionUnauthorizeHint: 'Pour vous déconnecter de votre compte %{provider}, veuillez aller à %{url}',
  complete: 'Terminé',
  compressedX: '%{size} économisé(s) par la compression',
  compressingImages: 'Compression des images…',
  connectedToInternet: 'Connecté à Internet',
  copyLink: 'Copier le lien',
  copyLinkToClipboardFallback: 'Copier le lien ci-dessous',
  copyLinkToClipboardSuccess: 'Lien copié',
  creatingAssembly: 'Préparation de l’import...',
  creatingAssemblyFailed: 'Transloadit: Impossible de créer Assembly',
  dashboardTitle: 'Import de fichier',
  dashboardWindowTitle: 'Fenêtre d’import de fichiers (Appuyez sur échap pour fermer)',
  dataUploadedOfTotal: '%{complete} sur %{total}',
  discardRecordedFile: 'Supprimer la vidéo enregistrée',
  done: 'Terminé',
  dropHereOr: 'Déposer les fichiers ici ou %{browse}',
  dropHint: 'Déposez vos fichiers ici',
  dropPasteBoth: 'Déposer les fichiers ici, coller ou %{browse}',
  dropPasteFiles: 'Déposer les fichiers ici, coller ou %{browse}',
  dropPasteFolders: 'Déposer les fichiers ici, coller ou %{browse}',
  dropPasteImportBoth: 'Déposer les fichiers ici, coller, %{browse} ou importer de',
  dropPasteImportFiles: 'Déposer les fichiers ici, coller, %{browse} ou importer de',
  dropPasteImportFolders: 'Déposer les fichiers ici, coller, %{browse} ou importer de',
  editFile: 'Modifier le fichier',
  editImage: 'Modifier l’image',
  editFileWithFilename: 'Modifier le fichier %{file}',
  editing: 'Modification en cours de %{file}',
  emptyFolderAdded: 'Aucun fichier n’a été ajouté depuis un dossier vide',
  encoding: 'Traitement...',
  enterCorrectUrl: 'Lien incorrect: Assurez-vous que vous entrez un lien direct vers le fichier',
  enterTextToSearch: 'Entrez votre recherche d’images',
  enterUrlToImport: 'Entrez le lien pour importer un fichier',
  error: 'Erreur',
  exceedsSize: 'Ce fichier dépasse la taille maximale autorisée de %{size}',
  failedToFetch: 'Companion a échoué à récupérer ce lien, assurez-vous qu’il est correct',
  failedToUpload: 'L’import de %{file} a échoué',
  filesUploadedOfTotal: {
    0: '%{complete} sur %{smart_count} fichier importé',
    1: '%{complete} sur %{smart_count} fichiers importés',
  },
  filter: 'Filtrer',
  finishEditingFile: 'Terminer l’édition du fichier',
  flipHorizontal: 'Retourner horizontalement',
  folderAdded: {
    0: '%{smart_count} fichier ajouté de %{folder}',
    1: '%{smart_count} fichiers ajoutés de %{folder}',
  },
  folderAlreadyAdded: 'Le répertoire "%{folder}" a déjà été ajouté',
  generatingThumbnails: 'Génération des miniatures ...',
  import: 'Importer',
  importFiles: 'Importer des fichiers de:',
  importFrom: 'Importer de %{name}',
  inferiorSize: 'The fichier est plus petit que la taille autorisée de %{size}',
  loadedXFiles: '%{numFiles} fichiers chargés',
  loading: 'Chargement...',
  logOut: 'Déconnexion',
  micDisabled: 'Accès au micro refusé par l’utilisateur',
  missingRequiredMetaField: 'Champs meta obligatoire manquant',
  missingRequiredMetaFieldOnFile: 'Champs meta obligatoires manquants pour %{fileName}',
  missingRequiredMetaFields: {
    0: 'Champs meta obligatoire manquant: %{fields}.',
    1: 'Champs meta obligatoires manquants: %{fields}.',
  },
  myDevice: 'Mon Appareil',
  noAudioDescription: 'Pour enregistrer de l\'audio, veuillez connectecter un microphone ou un autre périphérique audio',
  noAudioTitle: 'Microphone indisponible',
  noCameraDescription: 'Pour prendre des photos ou enregistrer une vidéo, veuillez connecter une caméra',
  noCameraTitle: 'Caméra indisponible',
  noDuplicates: 'Impossible d’ajouter le fichier "%{fileName}", il existe déjà',
  noFilesFound: 'Vous n’avez aucun fichier ou dossier ici',
  noInternetConnection: 'Pas de connexion à Internet',
  noMoreFilesAllowed: 'Impossible d’ajouter de nouveaux fichiers: en cours de chargement',
  noSearchResults: 'Aucun résultat pour cette recherche',
  openFolderNamed: 'Ouvrir %{name}',
  pause: 'Pause',
  paused: 'En pause',
  pauseUpload: 'Mettre en pause l’import',
  pluginNameAudio: 'Audio',
  pluginNameBox: 'Box',
  pluginNameCamera: 'Camera',
  pluginNameDropbox: 'Dropbox',
  pluginNameFacebook: 'Facebook',
  pluginNameGoogleDrive: 'Google Drive',
  pluginNameInstagram: 'Instagram',
  pluginNameOneDrive: 'OneDrive',
  pluginNameZoom: 'Zoom',
  poweredBy: 'Propulsé par %{uppy}',
  processingXFiles: {
    0: 'Traitement de %{smart_count} fichier',
    1: 'Traitement de %{smart_count} fichiers',
  },
  recording: 'Enregistrement',
  recordingLength: 'Durée d’enregistrement %{recording_length}',
  recordingStoppedMaxSize: 'L’enregistrement s’est arrété car la taille du fichier dépasse la limite',
  recordVideoBtn: 'Enregistrer Video',
  recoveredAllFiles: 'Nous avons restauré tous les fichiers. Vous pouvez maintenant reprendre l\'import.',
  recoveredXFiles: {
    0: 'Nous n\'avons pas pu restaurer 1 fichier. Veuillez le re-sélectionner et reprendre l\'import.',
    1: 'Nous n\'avons pas pu restaure %{smart_count} fichier. Veuillez leq re-sélectionner et reprendre l\'import.',
  },
  removeFile: 'Effacer le fichier %{file}',
  reSelect: 'Re-sélectionner',
  resetFilter: 'Réinitialiser le filtre',
  resetSearch: 'Réinitialiser la recherche',
  resume: 'Reprendre',
  resumeUpload: 'Reprendre l’import',
  retry: 'Réessayer',
  retryUpload: 'Réessayer l’import',
  revert: 'Rétablir',
  rotate: 'Pivoter',
  save: 'Enregistrer',
  saveChanges: 'Sauvegarder les modifications',
  search: 'Rechercher',
  searchImages: 'Rechercher des images',
  selectX: {
    0: 'Sélectionner %{smart_count}',
    1: 'Sélectionner %{smart_count}',
  },
  sessionRestored: 'Session restaurée',
  showErrorDetails: 'Montrer les détails de l\'erreur',
  signInWithGoogle: 'S\'authentifier avec Google',
  smile: 'Souriez !',
  startAudioRecording: 'Commencer l’enregistrement audio',
  startCapturing: 'Commencer la capture de l’écran',
  startRecording: 'Commencer l’enregistrement vidéo',
  stopAudioRecording: 'Arrêter l’enregistrement audio',
  stopCapturing: 'Arrêter la capture de l’écran',
  stopRecording: 'Arrêter l’enregistrement vidéo',
  streamActive: 'Stream actif',
  streamPassive: 'Stream passif',
  submitRecordedFile: 'Envoyer la vidéo enregistrée',
  takePicture: 'Prendre une photo',
  takePictureBtn: 'Prendre photo',
  timedOut: 'Import bloqué durant %{seconds} secondes, annulation.',
  upload: 'Importer',
  uploadComplete: 'Import terminé',
  uploadFailed: 'L’import a échoué',
  uploading: 'Import en cours',
  uploadingXFiles: {
    0: 'Import de %{smart_count} fichier',
    1: 'Import de %{smart_count} fichiers',
  },
  uploadPaused: 'Import en pause',
  uploadStalled: 'Import bloqué depuis %{seconds} secondes. Il est peut-être nécessaire de recommencer l’opération.',
  uploadXFiles: {
    0: 'Importer %{smart_count} fichier',
    1: 'Importer %{smart_count} fichiers',
  },
  uploadXNewFiles: {
    0: 'Importer +%{smart_count} fichier',
    1: 'Importer +%{smart_count} fichiers',
  },
  xFilesSelected: {
    0: '%{smart_count} fichier sélectionné',
    1: '%{smart_count} fichiers sélectionnés',
  },
  xMoreFilesAdded: {
    0: '%{smart_count} autre fichier ajouté',
    1: '%{smart_count} autres fichiers ajoutés',
  },
  xTimeLeft: '%{time} restantes',
  youCanOnlyUploadFileTypes: 'Vous pouvez seulement importer: %{types}',
  youCanOnlyUploadX: {
    0: 'Vous pouvez seulement importer %{smart_count} fichier',
    1: 'Vous pouvez seulement importer %{smart_count} fichiers',
  },
  youHaveToAtLeastSelectX: {
    0: 'Vous devez sélectionner au moins %{smart_count} fichier',
    1: 'Vous devez sélectionner au moins %{smart_count} fichiers',
  },
  zoomIn: 'Zoomer',
  zoomOut: 'Dézoomer',
};
export default fr_FR;
